import { dataVolume } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVolume = /*#__PURE__*/createIcon(dataVolume)
export default IconVolume
